import React from 'react';
import {LegacyInputForm} from '@netx/core-components/Form/types';
import {type IAttributeTemplate} from '../../schema';
import {
	LegacyFormEditableAttribute,
	type LegacyFormEditableAttributeProps,
} from '../EditableAttribute';
import {
	ReadOnlyAttribute,
	type ReadOnlyAttributeProps,
} from '../ReadOnlyAttribute';

type CommonProps = {
	attrData: IAttributeTemplate;
	form?: LegacyInputForm;
	readOnly?: boolean;
};

export type LegacyFormAttributeProps = CommonProps &
	Omit<ReadOnlyAttributeProps, 'attrData'> &
	Omit<LegacyFormEditableAttributeProps, 'attrData' | 'form'>;

export const LegacyFormAttribute = ({
	attrData,
	readOnly,
	form,
	...props
}: LegacyFormAttributeProps) => {
	// TODO: we did something wrong in our attributes collection and system attributes that
	// are editable have a boolean ¯\_(ツ)_/¯
	if (
		readOnly ||
		attrData.permission === 'r' ||
		attrData.permission === (false as any)
	)
		return <ReadOnlyAttribute {...props} attrData={attrData} />;
	return (
		<LegacyFormEditableAttribute {...props} form={form} attrData={attrData} />
	);
};

export default LegacyFormAttribute;
